import styled from "styled-components";

const StyledCardsAndPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default StyledCardsAndPagination;
